module.exports = __webpack_public_path__ + "img/carrousel-rad-con-arco-1.bfc100e7.png";